export function isEmpty(value: any) {
    if (Array.isArray(value)) {
        return value.length == 0;
    } else {
        return [undefined, null, ''].includes(value);
    }
}
